import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

export type ImageCardProps =
    {
        alt: string;
        imageSrc: string;

        className?: string;
    };

const ImageCard: FunctionComponent<ImageCardProps> = ( props: ImageCardProps ) =>
    (
        <ImageCardWrapper>
            <ImageWrapper className={props.className}
                alt={props.alt}
                src={props.imageSrc}
            />
        </ImageCardWrapper>
    );

export default ImageCard;

const ImageWrapper = styled.img`
  max-width: 100%;
  height: auto;

  border: 5px solid ${props => props.theme.colors.silverLighter};
  border-radius: 5px;
`;

const ImageCardWrapper = styled.div`
  display: inline-block;
  
  margin: 30px 0px;
`;
